// frontend/src/components/files/types.ts

export interface FileItem {
  name: string
  type: 'file' | 'directory' | 'symlink'
  size: number
  permissions: string
  owner: string
  group: string
  modified: string
  blocked: boolean
  link_target?: string
}

export interface FileListResponse {
  path: string
  items: FileItem[]
}

export interface FileReadResponse {
  path: string
  content?: string
  presigned_url?: string
  size: number
  permissions?: string
  owner?: string
  group?: string
  language: string
}

export const ALLOWED_ROOTS = ['/home/ubuntu', '/var/log'] as const

export const LANGUAGE_COLORS: Record<string, string> = {
  Shell: 'green',
  Python: 'blue',
  JavaScript: 'yellow',
  TypeScript: 'blue',
  YAML: 'orange',
  JSON: 'teal',
  Config: 'gray',
  Log: 'dimmed',
  Markdown: 'violet',
  XML: 'pink',
  SQL: 'cyan',
  Text: 'gray',
}

export interface PinnedFileBrowser {
  id: string
  instanceId: string
  instanceName: string
  tenantId: number
  position: { x: number; y: number }
  size: { w: number; h: number }
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
